module.exports = __webpack_public_path__ + "fonts/Gibson-Light.53a2e889.woff2";